import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  // 首页
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index.vue')
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: { hideBanner: true, hideFooter: true }
  },
  // 介绍
   {
    path: '/list',
    name: 'list',
    component: () => import('@/views/list.vue'),
    children: [
      //列表
      {
        path: 'link_list',
        name: 'linkList',
        component: () => import('@/views/link_list.vue')
      },
      //详情
      {
        path: 'link_detail',
        name: 'linkDetail',
        component: () => import('@/views/detail.vue')
      },
    ]
  },
  //证书查询
  {
    path: '/education',
    name: 'education',
    component: () => import('@/views/education.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
